<template>
<div class="panel">
    <div class="row columns">
        <div class="panel-title big-title">
            Rapport de match
        </div>
        <template v-if="matchReport && teamReport">
            <wizard :step="real_step" :isDB="false"></wizard>
            <hr>
            <div class="row columns">
                <div class="large-3 columns text-centered panel-title team-name">
                    {{team.name}}
                </div>
                <div class="large-3 columns large-centered text-centered panel-title">
                    Actions des joueurs :
                </div>
            </div>
            <div class="row columns">
                <div class="large-8 columns large-centered note">
                    NB : la colonne agressions concerne les agressions <strong>réussies</strong> uniquement.
                </div>
              <div class="large-8 columns large-centered note">
                NB2 : la colonne <strong>XP Bonus</strong> est là pour gérer tous les trucs chelous des prières de nuffle, sans pourrir nos chères stats.
              </div>
              <br>
            </div>
            <div class="large-3 columns">
                    <div class="note">les champs marqués d'un * sont optionnels</div>
            </div>
            <div class="panel-content">
                <div class="row columns ">
                  <playerReportEditor
                      ref="preditor"
                      :team_id="teamid"
                      :team_report_id="id">
                  </playerReportEditor>
                </div>
                <br>
                <br>
                <template v-if="!matchReport.is_db_report">
                    <template v-if="teamReport.inducement != 'None' ">
                        <div class="row columns ">
                          <starReportEditor ref="sreditor"
                              :team_id="teamid"
                              :team_report_id="id">
                          </starReportEditor>
                        </div>
                        <br>
                    </template>
                    <div class="row columns " v-if="detailedTeam && detailedTeam.rostered_star_player">
                      <RosteredStarReportEditor ref="rostered_sreditor"
                        :team_report_id="id"
                        :team_id="teamid"
                        :rostered_star_name="detailedTeam.rostered_star_player.ref_star_player.name"
                        :rostered_star_id="detailedTeam.rostered_star_player.id">
                      </RosteredStarReportEditor>
                    </div>
                </template>

                <br>
                <div class="row columns">
                    <div v-if="error_msg" class="large-8 columns large-centered error-lbl">
                        {{error_msg}}
                    </div>
                    <br>
                </div>
                <div class="row columns">
                    <div class="large-2 columns large-offset-4">
                        <button  @click="previous" class="full-width light-grey-button">précédent</button>
                    </div>
                    <div class="large-2 columns end">
                        <button  @click="next" class="full-width">Suivant</button>
                    </div>
                </div>
            </div>
        </template>
        <div v-else>
            <spinner></spinner>
        </div>
    </div>
</div>
</template>

<script>
import spinner from '../common/spinner.vue'
import wizard from '../common/wizard.vue'
import { mapGetters } from 'vuex'
import playerReportEditor from './player-report-editor.vue'
import starReportEditor from './star-report-editor.vue'
import RosteredStarReportEditor from './rostered-star-report-editor'

export default {
  name: 'mrStep3',
  components: {
    spinner,
    wizard,
    playerReportEditor,
    starReportEditor,
    RosteredStarReportEditor
  },
  props: {
    'id': Number,
    'teamid': Number,
    'matchId': Number
  },
  data () {
    return {
      'player_actions': [],
      'player_injuries': [],
      'error_msg': null,
      'isInit': false
    }
  },
  watch: {
    '$route' (to, from) {
      this.$store.dispatch('purgeDetailedTeam')
      this.$store.dispatch('purgeTeamReport')
      this.$store.dispatch('getTeamReport', to.params.id)
      this.$store.dispatch('getDetailedMatchReport', to.params.matchId)
      this.$store.dispatch('getDetailedTeam', this.teamid)
    }
  },
  computed:
  {
    ...mapGetters([
      'currentUser',
      'teamReport',
      'teamReportList'
    ]),
    ...mapGetters({
      matchReport: 'detailedMatchReport',
      detailedTeam: 'detailedTeam'
    }),
    team: function () {
      return this.teamReport.team
    },
    real_step: function () {
      if (this.matchReport === undefined) {
        console.log('real step undefined')
        return 2
      }
      let currentTRidx = 0
      if (this.matchReport.is_db_report) {
        return 2
      } else {
        if (this.matchReport.home_report.team.id === this.teamid) {
          currentTRidx = 2
        } else {
          currentTRidx = 3
        }
      }
      return currentTRidx
    }
  },
  methods: {
    validate_reports () {
      this.$refs.preditor.validate(false)
      // pour un dungeon bowl, pas d'inducement
      if (this.matchReport.is_db_report === false) {
        if (this.teamReport.inducement && this.teamReport.inducement !== 'None') {
          this.$refs.sreditor.validate(false)
        }
        if (this.detailedTeam && this.detailedTeam.rostered_star_player) {
          this.$refs.rostered_sreditor.validate(false)
        }
      }
    },
    findTeamReportIndex () {
      return this.teamReportList.findIndex(tr => {
        return tr.team.id === this.teamid
      })
    },
    next () {
      this.validate_reports()
      if (this.matchReport.is_db_report) {
        this.next_db()
      } else {
        this.next_regular()
      }
    },
    next_db () {
      let currentIndex = this.findTeamReportIndex()
      if (currentIndex === this.teamReportList.length - 1) {
        this.$router.push({name: 'mrDBStep4', params: { id: this.matchId }})
      } else {
        this.$router.push({
          name: 'mrStep3',
          params: {
            id: this.teamReportList[currentIndex + 1].id,
            teamid: this.teamReportList[currentIndex + 1].team.id,
            matchId: this.matchId
          }
        })
      }
    },
    next_regular () {
      if (this.real_step === 3) {
        // si le match est un db il faut rediriger au bon endroit :
        this.$router.push({
          name: 'mrStep5',
          params: {
            id: this.matchId
          }
        })
      } else {
        this.$router.push({
          name: 'mrStep3',
          params: {
            id: this.matchReport.visitor_report.id,
            teamid: this.matchReport.visitor_report.team.id,
            matchId: this.matchId
          }
        })
      }
    },
    previous () {
      this.validate_reports()
      if (this.matchReport.is_db_report) {
        this.previous_db()
      } else {
        this.previous_regular()
      }
    },
    previous_db () {
      let currentIndex = this.findTeamReportIndex()
      if (currentIndex === 0) {
        this.$router.push({name: 'mrDBStep2', params: { id: this.matchId }})
      } else {
        this.$router.push({
          name: 'mrStep3',
          params: {
            id: this.teamReportList[currentIndex - 1].id,
            teamid: this.teamReportList[currentIndex - 1].team.id,
            matchId: this.matchId
          }
        })
      }
    },
    previous_regular () {
      if (this.real_step === 2) {
        this.$router.push({name: 'mrStep2', params: { id: this.matchId }})
      } else {
        this.$router.push({
          name: 'mrStep3',
          params: {
            id: this.matchReport.home_report.id,
            teamid: this.matchReport.home_report.team.id,
            matchId: this.matchId
          }
        })
      }
    },
    getRosterIcon () {
      return '/static/imgs/team-icons/' + this.team.ref_roster.replace(/\s+/, '') + '.png'
    }
  },
  mounted () {
    this.$store.dispatch('purgeDetailedTeam')
    this.$store.dispatch('hideLeaguePanel')
    this.$store.dispatch('deactivateFullSizePage')
    this.$store.dispatch('purgeTeamReport')
    this.$store.dispatch('getTeamReport', this.id)
    this.$store.dispatch('getDetailedMatchReport', this.matchId)
    this.$store.dispatch('getDetailedTeam', this.teamid)
    this.$store.dispatch('getTeamReportListForMatch', this.matchId)
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.big-title {
    font-size: 1.6rem;
}
.team-name {
    font-size: 1.6rem;
    padding: 0rem;
}
.match-team-name {
    font-size: 1.3rem;
}
.roster tr:nth-of-type(odd) {
    transition: background-color 0.15s;
    background-color: #E9EDEF;
}

.roster tr:nth-of-type(even) {
    background-color: #ffffff;
}

/***** gestion des formats de cellules*/

thead tr th {
    background-color: #ffffff;
    text-align: center;
    font-weight: 200;
    font-size:0.8rem;
}

tr td{
    padding: 0.5rem 0.2rem;
    text-align: center;
    font-size:0.7rem;
}
tr td input, tr td select{
    padding: 0.5rem 0.5rem;
    text-align: center;
    font-size:0.7rem;
    margin: 0rem;
}

.roster tr td.sous-total{
    font-weight: 400;
    padding: 0.4rem 0rem;
}


.roster tr td.sous-total.right{

}

button.row{
    margin-left: 0.4rem;
}

.note {
 font-size: 0.6rem;
}

</style>



// WEBPACK FOOTER //
// mr-step-3.vue?a7c04a96